import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json'
import fr from './locales/fr.json'

const userLanguage = navigator.language || navigator.languages[0]

const languageFormLocal = localStorage.getItem('langague');

i18n

  .use(initReactI18next)
  
  .init({
    resources:{
        en:{translation: en},
        fr:{translation: fr}
    },
    lng: languageFormLocal ? languageFormLocal : userLanguage,
    fallbackLng: 'fr',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;